// extracted by mini-css-extract-plugin
module.exports = {"container":"todo-list_container__1aA8l","list":"todo-list_list__3AIOg"};